<template>
    <div id="contWrapper">
        <div id="contBox">
            <img src="../../assets/imgs/news/sorry.gif" v-if="!sorryShow">
            <div v-if="sorryShow">
                <div id="contTitle">{{newCont.title}}</div>
                <div id="contTIme">发布于：{{newCont.year}}-{{newCont.day}}</div>
                <div id="contText" v-html="newCont.cont"></div>
            </div>
        </div>
    </div>
</template>

<script>
import {data_test} from '@/assets/js/data.js'
// 引入data.js 文件
const newList = {
    data_test
}
export default {
    name: 'Cont',
    data(){
        return{
            newCont:[], 
            num:null, //文章id
            sorryShow:1, //错误图片是否展示，0展示，1不展示·
            count:3,//倒计时
            timer:{},//定时器
        }
    },
    methods:{
        jumpPage(){
            this.$router.push({path: '/news'});
        }
    },
    mounted(){
        // 先获取路由参数
        this.num = this.$route.query.id
        newList.data_test.map((value)=>{
            if(value.id == this.num){
                this.newCont = value
            }
        })
        if(this.newCont.cont == ''){
            this.sorryShow = 0;
            this.timer = setInterval(this.jumpPage, 5000); //延迟执行
        }
    },
    beforeDestroy() {
        //离开页面销毁定时器
        if(this.timer) { //如果定时器还在运行 或者直接关闭，不用判断 
            clearInterval(this.timer); //关闭
        }
    }
}
</script>

<style>
    #contWrapper{
        background: #edf0f5;
    }
    #contBox{
        width: 980px;
        margin: 0 auto;
        background: #fff;
        padding: 30px 70px 80px 70px;
    }
    #contBox>img{
        width: 745px;
        margin: 0 auto;
        display: block;
        
    }
    #contTitle{
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        width: 500px;
        margin: 0 auto;
    }
    #contTIme{
        text-align: center;
        color: #646464;
        margin-top: 20px;
        margin-bottom: 30px;
    }
    #contText{
        text-indent: 28px;
        font-size: 14px;
        line-height: 25px;
    }
    #contText img{
        max-width: 595px;
        margin: 20px auto;
        display: block;
    }
    .img-title{
        text-align: center;
        font-weight: bold;
    }
    .text-cent{
        text-align: center;
    }
</style>
